export default __webpack_public_path__ + "static/media/more.f52f6a7c.svg";